import { API_BASE_URL } from "../common/config.js";
import authHeader from "./auth-header";

export const updateDb = async (url, body, method = "post") => {
  let reqHeaders = authHeader();
  reqHeaders["Content-Type"] = "application/json";

  try {
    const response = await fetch(API_BASE_URL + url, {
      method: method,
      body: JSON.stringify(body),
      headers: reqHeaders,
    });

    // Check if the response is successful (status code in the range 200-299)
    if (response.ok) {
      const data = await response.json();
      return { success: true, data: data }; // Return success response
    } else {
      // For non-successful responses, attempt to parse error message
      try {
        const errorData = await response.json();
        return { success: false, error: errorData.msg || errorData.error || "An error occurred" };
      } catch (error) {
        // In case the error response isn't in JSON format or another error occurs
        return { success: false, error: "An error occurred" };
      }
    }
  } catch (error) {
    // Handle network errors or other issues with the fetch request
    return { success: false, error: error.message || "Network error" };
  }
};
